import React from 'react'
import {connect} from 'react-redux'
import {compose, lifecycle} from 'recompose'
import WithAjax from '../common/helpers/WithAjax'
import TabList from '../common/helpers/TabList'
import {setJumbotronTitle} from '../../actions/common'
import {clearProduction, fetchProductionOverviewSuccess} from '../../actions/pages/production-page'

import ProductionOverview from './ProductionOverview'
import VacanciesGrid from './VacanciesGrid'
import VoiceTestsGrid from './VoiceTestsGrid'

const mapStateToProps = (state, ownProps) => ({
  overview: state.productionPage.overview,
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) },
  clearProduction() { dispatch(clearProduction()) },
  fetchProductionOverviewSuccess(overview) { dispatch(fetchProductionOverviewSuccess(overview)) }
})

const ProductionEdit = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.fetchProduction();
    },
    componentDidUpdate(prevProps) {
      if (this.props.overview === null && !this.props.isLoading) {
        this.fetchProduction();
      }
    },
    fetchProduction() {
      let id = parseInt(this.props.match.params.id, 10);

      let url = 'productions/' + id;

      this.props.clearProduction();
      this.props.ajax.get(url, true, (data) => {
        this.props.setJumbotronTitle(data.OriginalTitle);
        this.props.fetchProductionOverviewSuccess(data);

        let id = parseInt(this.props.match.params.id, 10);

        if (!Number.isInteger(id)){
          return;
        }

        this.setState({
          contentItems: [
            {
              label: 'Overview',
              link: 'overview',
              content: <ProductionOverview productionId={id} />
            },
            {
              label: 'Voice tests',
              link: 'voiceTests',
              content: <VoiceTestsGrid productionId={id} />
            },
            {
              label: 'Creative team',
              link: 'creativeTeam',
              content: <VacanciesGrid productionId={id} />
            }
          ]
        });
      });
    }
  })
)

export default WithAjax(ProductionEdit(TabList))